// Chosen after testing/calibration
export const FUSE_OPTIONS = {
  ignoreFieldNorm: true,
  ignoreLocation: true,
  threshold: 0.15,
};
